const React = require('react');
const delay = require('mn-utils/delay');
const noop = require('mn-utils/noop');
const trim = require('mn-utils/trim');
const map = require('mn-utils/map');
const find = require('mn-utils/find');
const TextField = require('@material-ui/core/TextField').default;
const {
  apiAdminMerchantsFilter,
} = require('../../../../api/admin/merchants');
const withState = require('../../../../utils/withState');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const Ripple = require('../../../dumb/Ripple');
const Loading = require('../../../dumb/Loading');


module.exports = withState((setState, self, onMount) => {
  let _email = '';
  let _id = '';
  let _cancel = noop;

  function update() {
    _cancel();
    _cancel = delay(() => {
      if (_email.length < 2) {
        setState({
          items: [],
        });
        return;
      }
      setState({
        loading: true,
      });
      _cancel = delay(() => {
        _cancel = apiAdminMerchantsFilter({
          email: _email,
        }).finally((error, response) => {
          // console.log({id, err, item});
          setState({
            loading: false,
            items: response && response.list || [],
          });
        }).cancel;
      }, 500);
    });
  }
  function setEmail(email) {
    setState({
      email,
    });
  }

  onMount(() => {
    return () => {
      _cancel();
    };
  });

  return (state, {
    label,
    helperText,
    className,
    ...props
  }) => {
    function handleChange(id) {
      delay(props.onChange, 0, [{
        target: {
          value: id,
        },
      }]);
    }
    const {
      loading,
    } = state;
    const email = state.email || '';
    const items = state.items || [];
    const trimedEmail = trim(email);
    const findedItem = find(items, ['email', trimedEmail]);
    const findedId = findedItem && findedItem.id || '';
    _id === findedId || handleChange(_id = findedId);
    findedItem || _email === trimedEmail || update(_email = trimedEmail);
    return (
      <div className={'layoutRow fhaS fvaC w ' + (className || '')}>
        <div
          className="c8B8D93 f14 fw5 w(|min)90 pr10 ff$2 __label"
        >{label}</div>
        <div className="fx1 wmin0 rlv">
          <TextField
            margin="none"
            variant="outlined"
            {...props}
            value={props.disabled ? props.value : email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            className={
              `w (pv17|pt14|ph20|h52|bxzBB)>.*OutlinedInput-input
              o50>.*input.Mui-disabled
              (dn|f14|fw5|c1D1E20|ff$2)>.*OutlinedInput-root*2
              (r8|b1.5|bcEDEEF0(>*|:h>*|>.*-focused):not[.*-error])>.*-notchedOutline*2
              `}
          />
          {
            loading ? (
              <div className="abs svr w50">
                <Loading/>
              </div>
            ) : null
          }
          <div className="rlv">
            {
              props.error ? (
                <div
                  className="abs sh20 st f12 cEC4C4C fw4"
                >{helperText || 'Obligatory field'}</div>
              ) : null
            }
            {
              !findedItem && items.length ? (
                <WrapperWithLoading
                  className="abs sht z2"
                  loading={loading}
                >
                  <div className="bs b2 bcE ovyA ovx hmax50vh bgF r8">
                    {map(items, (item) => {
                      const {
                        email,
                      } = item;
                      return (
                        <Ripple
                          key={item.id}
                          className="layoutRow fhaS fvaC h40 ph15 bs b1 bcF0 c0
                            bcbE bcbF0:last"
                          onClick={() => {
                            setEmail(email);
                          }}
                        >{email}</Ripple>
                      );
                    }, [])}
                  </div>
                </WrapperWithLoading>
              ) : null
            }
          </div>
        </div>
      </div>
    );
  };
}, {});
